import React from 'react'
import PropTypes from 'prop-types'

import { Icon60FileClip } from '../SVGIcons'

import './UploadingFile.scss'

export const UploadingFile = ({ name, size }) => {
  return (
    <div className='e-uploading-file'>
      <div className='e-uploading-file__icon'>
        <Icon60FileClip />
      </div>
      <div className='e-uploading-file__details'>
        <div className='e-uploading-file__details__row'>
          <div className='e-uploading-file__details__filename'>{name}</div>
          <div className='e-uploading-file__details__spinner' />
        </div>
        <div className='e-uploading-file__details__size'>{size}</div>
      </div>
    </div>
  )
}

UploadingFile.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.node.isRequired
}
